
jQuery(function () {
    window.addEventListener(
        "mouseover",
        function onFirstHover() {
            jQuery("html").addClass("has-mouse");
            window.removeEventListener("mouseover", onFirstHover, false);
        },
        false
    );

    jQuery('body').on('click', '.footer-menu__open-menu', function () {
        jQuery('.footer-menu__content').addClass('show');
    });

    jQuery('body').on('click', '.footer-menu__close-button', function () {
        jQuery('.footer-menu__content').removeClass('show');
    });

});




jQuery(document).ready(function() {
    //initialize swiper when document ready
    var swiper = new Swiper(".features__wrapper", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: true,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
            loop: true,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: true,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: true,
          },
        },
      });
});

